import React from "react";
import {
  cargarImagen,
  crearNuevoProveedor,
  editarProveedor,
  subirImagen,
} from "./ProveedorFirmaService";
import Resizer from "react-image-file-resizer";
import { logout } from "../login/SesionService";
import { psa } from "../../constans/constants";
import { validateForm } from "../../constans/validationUtils";
import validarImagen from "../seguridad/ValidadorImagen";
import DropzoneComponent from "../componentes/DropzoneComponent";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from '../mensajeFlash/PantallaCarga';
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput
} from '../../constans/form-error-utils';
 
class ProveedorFirma extends React.Component {
  constructor(props) {
    super(props);
 
    const { tipoAccion } = props.match.params;
 
    const originalHandleInput = this.handleInput;
 
    this.handleInput = integrarConHandleInput(this, originalHandleInput);
 
    this.state = {
      id: "",
      clientSecret: "",
      clientId: "",
      schema: "",
      host: "",
      port: "",
      activo: "",
      codigoCliente: "",
      mostrarMensaje: false,
      mensaje: "",
      logo: null,
      urlLogo: "",
      openPantallaCarga: false,
      errors: {
        clientSecret: null,
        clientId: null,
        schema: null,
        host: null,
        port: null,
        codigoCliente: null,
        descripcion: null,
      },
      tipoAccion,
      titulo: null,
      mensajeFlash: "",
      mostrarMensajeFlash: false,
      mensajeFlashSeverity: "neutral",
      showErrors: false
    };
  }
 
  reglasValidacionCampos = {
    clientSecret: [
      { required: true, message: 'Campo obligatorio' }
    ],
    clientId: [
      { required: true, message: 'Campo obligatorio' }
    ],
    schema: [
      { required: true, message: 'Campo obligatorio' },
    ],
    host: [
      { required: true, message: 'Campo obligatorio' },
    ],
    port: [
      { required: true, message: 'Campo obligatorio' },
    ],
    codigoCliente: [
      { required: true, message: 'Campo obligatorio' },
    ],
    descripcion: [
      { required: true, message: 'Campo obligatorio' }
    ]
  }
 
 
  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };
 
  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };
 
 
 
  handleUploadLogo = async (archivo) => {
    const resultadoAnalisis = await validarImagen(archivo)
    if (resultadoAnalisis) {
      try {
        Resizer.imageFileResizer(
          archivo,
          200, 150,
          "PNG",
          0, 0,
          (uri) => {
            this.setState({
              urlLogo: URL.createObjectURL(uri),
              logo: uri
            })
          },
          "file",
        )
 
      } catch (error) {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: "Ocurrio un error durante la carga de la imagen",
          mensajeFlashSeverity: "error"
        });
      }
    } else {
      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash: resultadoAnalisis.error,
        mensajeFlashSeverity: "error"
      })
    }
 
  }
 
  handleProveedorSubmit = (e) => {
    e.preventDefault();
    let { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (!isValid) {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    } else {
      this.setState({ openPantallaCarga: true });
      mostrarErroresEnFormulario({});
      const data = {
        id: this.state.id,
        clientSecret: this.state.clientSecret,
        clientId: this.state.clientId,
        schema: this.state.schema,
        host: this.state.host,
        port: this.state.port,
        activo: this.state.activo,
        descripcion: this.state.descripcion,
        codigoCliente: this.state.codigoCliente,
      };
      if (this.state.tipoAccion === "edit") {
        editarProveedor(data).then((response) => {
          if (response.error === true) {
            this.setState({
              mensajeFlash: response.mensaje,
              mostrarMensajeFlash: true,
              mensajeFlashSeverity: "error",
              openPantallaCarga: false,
            });
          } else {
            if (this.state.logo != null) {
              var id = response.datos.id;
              var formData = new FormData();
              formData.append("file", this.state.logo);
              subirImagen(id, formData);
            }
            this.props.history.push({
              pathname: '/admin/proveedores-firma',
              state: {
                mensajeFlash: "PSA modificado exitosamente",
                mostrarMensajeFlash: true,
                mensajeFlashSeverity: "exito",
              }
            })
          }
        });
      } else if (this.state.tipoAccion === "add") {
        crearNuevoProveedor(data).then(
          (response) => {
            if (response.error === true) {
              this.setState({
                mensajeFlash: response.mensaje,
                mostrarMensajeFlash: true,
                mensajeFlashSeverity: "error",
                openPantallaCarga: false,
              });
            } else {
              if (this.state.logo != null) {
                var id = response.datos.id;
                var formData = new FormData();
                formData.append("file", this.state.logo);
                subirImagen(id, formData);
              }
              this.props.history.push({
                pathname: '/admin/proveedores-firma',
                state: {
                  mensajeFlash: "PSA modificado exitosamente",
                  mostrarMensajeFlash: true,
                  mensajeFlashSeverity: "exito",
                }
              })
            }
          },
          (error) => {
            if (error.response.status === 401) {
              logout();
            }
            return error;
          }
        );
      }
    }
  };
 
  componentDidMount() {
    if (this.state.tipoAccion === "edit") {
      const { proveedor } = this.props.location.state;
      this.setState({
        id: proveedor.id,
        clientSecret: proveedor.clientSecret,
        clientId: proveedor.clientId,
        descripcion: proveedor.descripcion,
        schema: proveedor.schema,
        host: proveedor.host,
        port: proveedor.port,
        activo: proveedor.activo,
        codigoCliente: proveedor.codigoCliente,
        titulo: "Datos del proveedor: " + proveedor.descripcion
      });
      cargarImagen(proveedor.id).then(
        (res) => {
          if (res != null) {
            this.setState({
              urlLogo: "data:image/png;base64," + res,
            });
          }
        },
        (error) => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        }
      );
    }
  }
 
  render() {
    return (
      <div>
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={'/admin/proveedores-firma'}
              breadcrumbs={
                [
                  { label: 'Proveedores de firma', path: '/admin/proveedores-firma' },
                  { label: this.props.match.params.tipoAccion !== 'edit' ? 'Nuevo proveedor' : 'Editar proveedor', path: '' }
                ]
              }
            />
 
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> {this.state.titulo ?? "Registrar nuevo proveedor de firma"}  </h1>
                <p className="page-description"> Complete el siguiente formulario con los datos correspondientes </p>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">
          <div className="page-container card">
            <div className="component-form">
              <div className="component-content">
                <form onSubmit={this.handleProveedorSubmit} className="form container-sm">
 
                  <div className="form-group">
                    <input type="text" name="descripcion" id="descripcion" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.descripcion} />
                    <label htmlFor="descripcion" className="form-label"> Descripcion </label>
                  </div>
 
                  <div className="form-group__inline">
 
                    <div className="form-group">
                      <input type="text" name="clientId" id="clientId" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.clientId} />
                      <label htmlFor="clientId" className="form-label"> Client Id </label>
                    </div>
 
                    <div className="form-group">
                      <input type="text" name="clientSecret" id="clientSecret" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.clientSecret} />
                      <label htmlFor="clientSecret" className="form-label">Client Secret</label>
                    </div>
 
                    <div className="form-group">
                      <input type="text" name="schema" id="schema" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.schema} />
                      <label htmlFor="schema" className="form-label">Schema</label>
                    </div>
 
                    <div className="form-group">
                      <input type="text" name="host" id="host" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.host} />
                      <label htmlFor="host" className="form-label">Host</label>
                    </div>
 
                    <div className="form-group">
                      <input type="text" name="port" id="port" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.port} />
                      <label htmlFor="port" className="form-label">Puerto</label>
                    </div>
 
                    <div className="form-group">
                      <select className="form-select" name="codigoCliente" id="codigoCliente" onChange={this.handleInput} value={this.state.codigoCliente}>
                        <option key="" value="" selected></option>
                        {psa.map((elemento) => (
                          <option key={elemento.codigo} value={elemento.codigo}>
                            {elemento.nombre}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="tipoEnvio" className="form-label"> Cliente </label>
                    </div>
 
                    <div className="form-group">
                      <input type="checkbox" className="form-check" name="activo" id="activo" onChange={this.handleChange} checked={this.state.activo} />
                      <label htmlFor="activo" className="check-label"> Activo </label>
                    </div>
 
                  </div>
 
                  <hr />
 
                  <div className="component-carga-apariencia">
 
                    <h3 className="form-subtitle"> Logo del proveedor </h3>
                    <p className="form-description"> Selecciona el archivo de imagen como logo para el proveedor</p>
                    <div className="container-flex center-content">
                      {
                        this.state.urlLogo &&
                        <div className="col">
                          <span className="form-midtitle"> Logo actual </span>
                          <div className="signature-area">
                            <img id="logoImg" src={this.state.urlLogo} className="img-fluid" alt="logo_empresa" />
                          </div>
                        </div>
                      }
 
                      <div className="col">
                        <span className="form-midtitle"> Seleccionar imagen </span>
                        <div className="carga-documento-section">
 
                          <div className="carga-documento-content">
                            <DropzoneComponent onFileSelected={this.handleUploadLogo} archivos_soportados={[".png", ".jpg"]} />
                          </div>
                        </div>
 
                      </div>
                    </div>
                  </div>
 
                  <div className="form-actions">
                    <button type="submit" className="btn-medium btn-primary"> Continuar </button>
                  </div>
                </form>
              </div>
            </div>
 
          </div>
        </div>
 
        <PantallaCarga mensaje={"Guardando cambios"} />
 
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />
      </div>
    );
  }
}
 
export default ProveedorFirma;